import { createApiRef } from '@backstage/core-plugin-api';

export interface MetricsQuery {
  projectId?: number;
  startDate?: string;
  endDate?: string;
  ref?: string;
  environments?: string[];
  excludeOwner?: string;
  excludeOwners?: string[];
  includeOwner?: string;
}

export interface AggregatedMetrics {
  totalDeployments: number;
  byEnvironment: Record<string, number>;
  topProjects: Array<{ projectId: number; projectName: string; count: number }>;
  monthlyTrend: Array<{ month: string; count: number }>;
  /** Indicates whether the excludeOwners filter was effectively applied. Undefined when not requested. */
  ownerFilterApplied?: boolean;
}

export interface ProjectInfo {
  projectId: number;
  projectName: string;
}

export interface SyncOptions {
  reset?: boolean;
}

export interface SyncStatus {
  syncing: boolean;
  phase: 'idle' | 'resetting' | 'discovering' | 'syncing' | 'done' | 'error';
  totalProjects: number;
  completedProjects: number;
  totalPipelines: number;
  currentProject: string | null;
  startedAt: string | null;
  finishedAt: string | null;
  error: string | null;
}

export interface DeployMetricsApi {
  getMetrics(query?: MetricsQuery): Promise<AggregatedMetrics>;
  getProjects(owner?: string): Promise<ProjectInfo[]>;
  triggerSync(options?: SyncOptions): Promise<void>;
  getSyncStatus(): Promise<SyncStatus>;
}

export const deployMetricsApiRef = createApiRef<DeployMetricsApi>({
  id: 'plugin.deploy-metrics.api',
});
